export default __webpack_public_path__ + "static/color-2-2f8e24567960bf10fe463e1a8b5e60a5.png";